import ProductErrorsInterface from '../types/error-response-content-interface'

export const emptyProductErrorsState: ProductErrorsInterface = {
  name: '',
  currency: '',
  price: '',
  sku: '',
  tax: '',
  weight: '',
  common: [],
  options: {},
  stock: '',
  shippingFeesDisabled: '',
  taxBehavior: '',
}
